import { Pipe, PipeTransform } from '@angular/core';
import { IDashboardGroup } from '@shared/interfaces/dashboard/dashboard-group';
import { ILoadedMaterial } from '@shared/interfaces/material/loaded-material';

@Pipe({ name: 'extractUsedMaterials' })
export class ExtractUsedMaterialsPipe implements PipeTransform {
  transform(data: IDashboardGroup[]): ILoadedMaterial[] {
    return data
      .map(group => group.devices).flat()
      .map(device => device.status?.currentLoadedMaterials).flat()
      .filter((material, index, materials) => materials?.findIndex(m => m.name === material.name) === index);
  }
}
